import {
  Hammer,
  Square,
  Wallpaper,
  PencilRuler,
  Sparkles,
  Wrench,
} from "lucide-react";

const services = [
  {
    icon: Sparkles,
    title: "Full Home Makeovers",
    desc: "End-to-end transformations for Resale and BTO flats — design, build, install and style.",
    tag: "Most loved",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    icon: Hammer,
    title: "Hacking & Masonry",
    desc: "Wall hacking, structural reworks and brickwork done cleanly, safely, on schedule.",
    span: "lg:col-span-3",
  },
  {
    icon: Square,
    title: "Flooring & Tiling",
    desc: "Vinyl, parquet, marble-look porcelain, terrazzo — laid by craftsmen who care.",
    span: "lg:col-span-2",
  },
  {
    icon: Wallpaper,
    title: "Wallpaper Install",
    desc: "Statement walls, calm bedrooms, kids' rooms — sourced and installed seamlessly.",
    span: "lg:col-span-1",
  },
  {
    icon: PencilRuler,
    title: "Interior Design",
    desc: "Elegant consultation rooted in how you actually live — quiet, warm, considered.",
    span: "lg:col-span-3",
  },
  {
    icon: Wrench,
    title: "Carpentry & Joinery",
    desc: "Bespoke wardrobes, TV consoles, vanities — built to last decades, not seasons.",
    span: "lg:col-span-3",
  },
];

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[color:var(--nr-bg-soft)] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 reveal">
          <div className="lg:col-span-5">
            <p className="overline mb-5">What we craft</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[color:var(--nr-ink)]">
              Services for the{" "}
              <em className="italic font-light text-[color:var(--nr-accent)]">
                whole home
              </em>
              .
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-[color:var(--nr-ink-soft)] text-base lg:text-lg leading-relaxed">
              One team. One quote. Everything from the first wall coming down
              to the last brass handle going in — managed under a single
              project lead, so you only ever speak to one person.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 lg:grid-cols-6 auto-rows-[minmax(220px,_auto)] gap-5 lg:gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`reveal group relative overflow-hidden rounded-2xl bg-[color:var(--nr-bg)] border border-[color:var(--nr-line)] p-7 lg:p-9 flex flex-col justify-between transition-all duration-500 hover:shadow-[0_30px_60px_-30px_rgba(45,36,34,0.25)] hover:-translate-y-1 ${s.span || ""}`}
              >
                {s.tag && (
                  <span className="absolute top-5 right-5 text-[0.65rem] uppercase tracking-[0.2em] px-3 py-1 rounded-full bg-[color:var(--nr-accent)]/10 text-[color:var(--nr-accent)] font-semibold">
                    {s.tag}
                  </span>
                )}
                <div>
                  <div className="w-12 h-12 rounded-full bg-[color:var(--nr-bg-soft)] flex items-center justify-center mb-6 ring-1 ring-[color:var(--nr-line)] group-hover:bg-[color:var(--nr-accent)] group-hover:text-white transition-colors duration-500">
                    <Icon size={20} className="text-[color:var(--nr-accent)] group-hover:text-white transition-colors duration-500" />
                  </div>
                  <h3 className="font-serif-display text-2xl lg:text-3xl text-[color:var(--nr-ink)] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[color:var(--nr-ink-soft)] leading-relaxed text-sm lg:text-base">
                    {s.desc}
                  </p>
                </div>
                <button
                  data-testid={`service-cta-${i}`}
                  onClick={() => scrollTo("#contact")}
                  className="mt-6 self-start link-underline text-xs uppercase tracking-[0.22em] font-semibold text-[color:var(--nr-ink)]"
                >
                  Enquire →
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
